module.exports = __webpack_public_path__ + "img/bizoverview.4f410ad1.png";